import { HeadingPhrases } from './HeadingPhrases'
import { useTranslation } from 'react-i18next'

const COMMITMENT_KEYS = ['free', 'unscored', 'honest'] as const

/** Independent guidance, with the merchant as its beneficiary. */
export function Commitments() {
  const { t } = useTranslation()

  return (
    <section
      id="commitments"
      aria-labelledby="commitments-title"
      className="lp-invert lp-commitments scroll-mt-24 py-20 sm:py-28"
    >
      <div className="mx-auto w-full max-w-6xl px-6 lg:px-10">
        <div className="max-w-[34rem]">
          <h2
            id="commitments-title"
            className="text-balance text-[2rem] font-semibold leading-[1.1] tracking-[-0.03em] sm:text-5xl"
            style={{ color: 'var(--lp-ink)' }}
          >
            <HeadingPhrases text={t('landing:commitments.title')} />
          </h2>
          <p
            className="mt-4 text-pretty text-lg leading-relaxed"
            style={{ color: 'var(--lp-body)' }}
          >
            {t('landing:commitments.subtitle')}
          </p>
        </div>

        {/*
         * Broadsheet columns, not a three-card feature row: no container, no
         * icon, no equal-height box. A single vertical rule separates them and
         * the columns are free to end where their copy ends.
         */}
        <ul className="mt-14 grid sm:mt-16 md:grid-cols-3">
          {COMMITMENT_KEYS.map((key, index) => (
            <li
              key={key}
              className={[
                'border-t pt-8',
                'md:border-t-0 md:pt-0',
                index === 0 ? 'md:pr-9' : 'mt-8 md:mt-0 md:border-l md:pl-9',
                index === 1 ? 'md:pr-9' : '',
              ].join(' ')}
              style={{ borderColor: 'var(--lp-rule)' }}
            >
              <h3
                className="text-balance text-[1.375rem] font-semibold leading-[1.25] tracking-[-0.02em]"
                style={{ color: 'var(--lp-ink)' }}
              >
                {t(`landing:commitments.items.${key}.title`)}
              </h3>
              <p
                className="mt-4 max-w-[25rem] text-pretty leading-[1.65]"
                style={{ color: 'var(--lp-body)' }}
              >
                {t(`landing:commitments.items.${key}.description`)}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
